import { render, staticRenderFns } from "./ShipmentPrototypeItemList.vue?vue&type=template&id=603928b0&scoped=true"
import script from "./ShipmentPrototypeItemList.vue?vue&type=script&lang=js"
export * from "./ShipmentPrototypeItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603928b0",
  null
  
)

export default component.exports